import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { replaceQueryString } from "@client/lib/api";
import { type HttpApiResponse } from "@client/types/Api";
import { type Purchase } from "./types";

export default {
  init: (apiInfo: ModuleApiInfo, args: Purchase.Api.InitRequest): Promise<HttpApiResponse<Purchase.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/purchase`, args),
  assignSystem: (
    apiInfo: ModuleApiInfo,
    data: Purchase.Api.AssignSystemRequest
  ): Promise<HttpApiResponse<Purchase.Api.AssignSystemResponse>> =>
    api.put(apiInfo, replaceQueryString(`/api/site/v1/modules/purchase/assignSystem`, apiInfo.baseParams), data),
  payment: async (
    apiInfo: ModuleApiInfo,
    data: Purchase.Api.PaymentRequest
  ): Promise<HttpApiResponse<Purchase.Api.PaymentResponse>> =>
    api.post(apiInfo, replaceQueryString(`/api/site/v1/modules/purchase/payment`, apiInfo.baseParams), data),
  setup: (
    apiInfo: ModuleApiInfo,
    data: Purchase.Api.SetupRequest
  ): Promise<HttpApiResponse<Purchase.Api.SetupResponse>> =>
    api.put(apiInfo, replaceQueryString(`/api/site/v1/modules/purchase/setup`, apiInfo.baseParams), data),
  verifyUser: async (
    apiInfo: ModuleApiInfo,
    data: Purchase.Api.VerifyUserRequest
  ): Promise<HttpApiResponse<Purchase.Api.VerifyUserResponse>> =>
    api.put(apiInfo, replaceQueryString(`/api/site/v1/modules/purchase/verifyUser`, apiInfo.baseParams), data)
};
